import React, { ReactElement } from 'react';
import { Route, Routes, useParams } from 'react-router';
import ElbilGuide from '../pages/ElbilGuide/ElbilGuide';
import BilModell, { path as bilModellPath } from '../pages/BilModell/BilModell';
import { NotFound } from '../loadable-elements/NotFound';

const BilModellRoute = (): ReactElement => {
  const { carSlug } = useParams<{ carSlug?: string }>();
  if (!carSlug) {
    return <NotFound />;
  }
  return <BilModell key={carSlug} carSlug={carSlug} />;
};

export const BilGuideRouter = (): ReactElement => (
  <Routes>
    <Route index element={<ElbilGuide />} />
    <Route path="null" element={<NotFound />} />
    <Route path={bilModellPath} element={<BilModellRoute />} />
  </Routes>
);
